import * as R from 'ramda';

import { Media } from '@atom/types/media';

import PhotoBlock from './PhotoBlock';
import { sortReportMedia } from './scdotReportUtilities';

import classes from './scdotPdfReport.module.css';

interface Props {
  media: Media[];
  mainPhotoId?: string;
}

const PhotoSection = ({ media, mainPhotoId }: Props) => {
  const sortedMedia = sortReportMedia(media, mainPhotoId);
  const groupedMedia = R.splitEvery(2, sortedMedia);

  return (
    <>
      {groupedMedia.map((items, index) => (
        <div className={classes.photosSection} key={index}>
          <div className={classes.photosSectionTitle}>Photos</div>
          {items.map(medium => (
            <PhotoBlock key={medium?.id} medium={medium} />
          ))}
        </div>
      ))}
    </>
  );
};

export default PhotoSection;
